import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { PasswordExpiredAccessService } from '../services/password-expired-access.service';


// Solo permite entrar a /psw-expired si el login detecto la contraseña vencida
// (acceso otorgado via PasswordExpiredAccessService) o si se llega con el token del mail (/psw-expired/:t),
// en cuyo caso el componente valida el token contra el backend.
export const passwordExpiredCanActivate: CanActivateFn = (next: ActivatedRouteSnapshot) => {
  const accessService = inject(PasswordExpiredAccessService);
  const router = inject(Router);

  if (accessService.hasAccess() || next.params['t']) {
    return true;
  }

  return router.createUrlTree(['/login']);
};
